export default class GHSphereGeometry extends THREE.SphereGeometry {
  constructor (rad, wseg, hseg) {
    super(rad, wseg, hseg);

    this.selectable = false;
    this.visible = true;
  }

  clone () {
    let newGHGeometry = new GHSphereGeometry();
    newGHGeometry.copy(this);
    newGHGeometry.selectable = this.selectable;

    return newGHGeometry;
  }

  setSelectable (sel) {
    this.selectable = sel;
  }

  setVisible (vis) {
    this.visible = vis;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/geometry/GHSphereGeometry.js